import {createTheme} from '@mui/material/styles';


export const muiTheme = createTheme({
	palette: {
		type: 'dark',
		primary: {
			main: '#29AE9A',
			contrastText: '#ddd',
		},
		secondary: {
			main: '#52AF99',
			contrastText: '#ddd',
		},
		background: {
			default: '#1B2431',
			paper: '#273142',
			paperLighter: '#313D4E',
			rowHover: '#434d5e',
			rowActive: '#212B3C',
			rowDark: '#212B3C',
			scrollMenu: '#313D4E',
			header: '#212B3C',
		},
		text: {
			primary: '#ddd',
			secondary: '#718093'
		},
		error: {
			main: '#da5750'
		},
		scrollbar: {
			thumbColor: '#3a4959',
			trackColor: '#222c3c',
			cornerColor: '#3a4959',
		},
		action: {
			disabled: 'rgba(255, 255, 255, 0.23)',
		},
		border: {
			normal: 'rgba(255, 255, 255, 0.23)'
		},
		json: {
			// theme for react-json-view
			// description at: https://github.com/chriskempson/base16/blob/master/styling.md
			base00: 'transparent',
			base01: 'transparent',
			base02: 'transparent',
			base03: '#718093',
			base04: '#da5750',
			base05: '#da5750',
			base06: '#da5750',
			base07: '#fff', // names
			base08: '#7aae1a', // ???
			base09: '#da5750', // strings
			base0A: '#7aae1a', // ???
			base0B: '#7aae1a', // float/double, big integer
			base0C: '#7aae1a', // indices
			base0D: '#7aae1a', // ???
			base0E: '#da5750', // keywords
			base0F: '#7aae1a', // int
		}
	},
	typography: {
		fontSize: 14,
		fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
		useNextVariants: true,
	},
	components: {
		MuiTypography: {
			styleOverrides: {
				root: {
					color: '#ddd',
				},
			}
		},
		MuiTab: {
			styleOverrides: {
				root: {
					'&.Mui-disabled': {
						color: 'rgb(255,255,255,0.2)',
					}
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: '12px',
					backgroundColor: '#434d5e',
					maxWidth: 400,
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: '#273142',
					height: 45,
					padding: 5,
					marginBottom: 2,
					boxShadow: 'none',
					flexDirection: 'row',
					display: 'flex',
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontSize: '10px',
					boxSizing: 'border-box',
					width: '100%',
				},
				gutters: {
					paddingLeft: 10,
					paddingRight: 10,
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					padding: 0,
					'&.Mui-selected': {
						background: 'rgba(255,255,255,.2)',
						'&:hover': {
							background: 'rgba(255,255,255,.2)',
						},
					},
					'&:hover': {
						background: 'rgba(255,255,255,.1)',
					},
				},
			}
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& label': {
						minWidth: '75px',
					},
					'& label.Mui-focused': {
						color: '#718093',
					},
					'& .MuiOutlinedInput-root': {
						'& fieldset': {
							borderColor: 'rgba(255, 255, 255, .23)',
						},
						'&.Mui-disabled input': {
							WebkitTextFillColor: '#ddd'
						},
						'&:not(.Mui-disabled):not(.Mui-error)': {
							'&:hover:not(:focus-within) fieldset': {
								borderColor: 'rgb(221, 221, 221)',
							},
							'&:focus-within fieldset': {
								borderColor: 'primary',
							},
							'&.Mui-focused fieldset': {
								borderColor: 'primary',
							},
						}
					},
				},
			}
		},
		MuiGrid: {
			styleOverrides: {
				root: {
					'& .MuiGrid-item': {
						maxWidth: '100%',
					},
				},
				'grid-xs-8': {
					maxWidth: 'calc(100% - 8px)',
				},
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					maxWidth: '100%',
					marginLeft: 4,
					marginTop: 2,
					marginBottom: 8,
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
				},
			},
		},
		MuiFormControl: {
			styleOverrides: {
				marginDense: {
					marginBottom: 0,
				},
				root: {
					'.MuiFormLabel-root': {
						color: '#718093',
						'&.Mui-disabled': {
							color: 'rgb(255,255,255,0.2)',
						}
					}

				}
			},
		},
		MuiLink: {
			styleOverrides: {
				root: {
					color: '#52AF99'
				},
			},
		},
	},
	border: '1px solid #313d4e',
});

export const muiStyles = theme => ({
	'@global': {
		'*::-webkit-scrollbar': {
			width: '8px',
			height: '8px',
		},
		'*::-webkit-scrollbar-track': {
			backgroundColor: muiTheme.palette.scrollbar.trackColor,
		},
		'*::-webkit-scrollbar-thumb': {
			backgroundColor: muiTheme.palette.scrollbar.thumbColor,
		},
		'*::-webkit-scrollbar-corner': {
			backgroundColor: muiTheme.palette.scrollbar.cornerColor,
		},
	}
});